import {
  getMeVisibilityGroupsTeams,
  getTeamsSearch,
} from "@aura-frontend/omnibus-az-client";
import { useQuery } from "@tanstack/react-query";

import { mapTeamDBToOption } from "../teamOption";

export type TeamHydration = {
  visibilityGroup: string;
  parentName: string | null;
};

export const useTeamVisibilityGroup = (teamUuid: string | undefined) => {
  return useQuery<TeamHydration | null>({
    queryKey: ["teamVisibilityGroup", teamUuid],
    enabled: !!teamUuid,
    queryFn: async () => {
      if (!teamUuid) return null;

      const { data } = await getMeVisibilityGroupsTeams({ throwOnError: true });
      const groups = data?.visibilityGroups ?? [];

      for (const visibilityGroup of groups) {
        const { data: teamsData } = await getTeamsSearch({
          query: { visibilityGroup, externalId: teamUuid },
          throwOnError: true,
        });
        const match = teamsData?.teams?.[0];
        if (match) {
          return {
            visibilityGroup,
            parentName: mapTeamDBToOption(match).meta?.parentName ?? null,
          };
        }
      }

      return null;
    },
  });
};
